import React from "react";
import PropTypes from "prop-types";
import PhoneCases from "./PhoneCases";
import Clothes from "./Clothes";
import Icon from "./Icon";
import Hoodie from "./Hoodie";

function Material(props) {
  const {department, category, productName} = props;
  const getMaterialComponent = () => {
    if (department === `phone_cases`) {
      return <PhoneCases {...props} />;
    } else if (category === `stickers` || category === `passport_covers`) {
      return <Icon {...props} />;
    } else if (productName === `hoodie`) {
      return <Hoodie {...props} />;
    } else {
      return <Clothes {...props} />;
    }
  };
  return getMaterialComponent();
}

Material.propTypes = {
  productName: PropTypes.string,
  department: PropTypes.string,
  category: PropTypes.string,
  name: PropTypes.string,
  content: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
      difference: PropTypes.number
    })
  ),
  current: PropTypes.string,
  onChange: PropTypes.func
};

export default Material;
